import { authenticatedRestClient } from 'helpers/restclient';
import { getListContextFromSearchListKey } from 'helpers/search';
import { getMarketplaceSourceTabFromTabName } from 'constants/marketplace';

const payloadGenerator = ({
	vehicles,
	focussedSearchListKey,
	isFeaturedVehicleCampaign,
	isVdp,
	forceRefresh,
	includeSummary,
	summaryVersions,
	offerSummarySaleType,
}) => {
	const offerRefreshData = {
		context: isVdp ? 'vehicle_detail' : getListContextFromSearchListKey(focussedSearchListKey),
		source_tab: getMarketplaceSourceTabFromTabName(focussedSearchListKey),
		featured_campaign: Boolean(isFeaturedVehicleCampaign),
		bid_sales: vehicles.map(({ bid_sale_id, version }) => ({
			id: bid_sale_id,
			version: forceRefresh ? undefined : version,
		})),
		sale_types: offerSummarySaleType,
	};

	if (includeSummary) offerRefreshData.summary = summaryVersions || [];

	return offerRefreshData;
};

export default class BuyerOffersService {
	static instance = new BuyerOffersService();

	_endpoints = { offerRefresh: `/api/offer_refresh/query`, offerRefreshV4: `/api/v4/offer_refresh/query` };

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	offerRefresh = ({
		vehicles,
		focussedSearchListKey,
		isFeaturedVehicleCampaign,
		isVdp,
		reason,
		forceRefresh,
		includeSummary,
		summaryVersions,
		offerSummarySaleType,
		cancelToken,
	}) => {
		const endpoint = `${this._endpoints.offerRefresh}?reason=${reason}&include_summary=${Boolean(includeSummary)}`;
		const offerRefreshData = payloadGenerator({
			vehicles,
			focussedSearchListKey,
			isFeaturedVehicleCampaign,
			isVdp,
			forceRefresh,
			includeSummary,
			summaryVersions,
			offerSummarySaleType,
		});
		return this.restClient.post(endpoint, offerRefreshData, {}, cancelToken);
	};

	offerRefreshV4 = ({
		vehicles,
		focussedSearchListKey,
		isFeaturedVehicleCampaign,
		isVdp,
		reason,
		forceRefresh,
		includeSummary,
		summaryVersions,
		offerSummarySaleType,
		cancelToken,
	}) => {
		const endpoint = `${this._endpoints.offerRefreshV4}?reason=${reason}&include_summary=${Boolean(includeSummary)}`;
		const offerRefreshData = payloadGenerator({
			vehicles,
			focussedSearchListKey,
			isFeaturedVehicleCampaign,
			isVdp,
			forceRefresh,
			includeSummary,
			summaryVersions,
			offerSummarySaleType,
		});
		return this.restClient.post(endpoint, offerRefreshData, {}, cancelToken);
	};
}
